import React from 'react';

// Maps a health status to the status-pill glyph + label. 'unknown' maps to the
// Partial state with an open circle so a service whose metrics could not be
// sampled is never shown as a false-green Healthy tile.
const PILL = {
  critical: { glyph: '●', label: 'Critical' },
  warning: { glyph: '●', label: 'Warning' },
  healthy: { glyph: '●', label: 'Healthy' },
  unknown: { glyph: '○', label: 'Partial' },
};

// Reusable trend seam. Infrastructure is collected live on every request and no
// dated snapshots are persisted, so the frontend has no historical series to
// draw a sparkline or delta from. This returns null today; a future snapshot
// source can supply `series` to light it up without reworking the tile.
export function renderTrend(series) {
  if (!series || !Array.isArray(series) || series.length === 0) return null;
  return null;
}

// Decorates an existing service tile element (the JSX already built in
// AccountDetail's serviceSections) with the status-first treatment: a colored
// left accent bar and a status pill. The card shows its full detail inline, so
// it is no longer a dialog trigger and carries no open/keyboard wiring.
// Using cloneElement keeps the existing tile definitions untouched while every
// tile uniformly gains the status treatment.
const ServiceTile = ({ serviceKey, status, tileElement }) => {
  if (!React.isValidElement(tileElement)) return tileElement || null;

  const safeStatus = PILL[status] ? status : 'unknown';
  const pill = PILL[safeStatus];

  const existingClass = tileElement.props.className || '';

  const pillNode = (
    <span className={`status-pill status-pill-${safeStatus}`} aria-hidden="true">
      <span className="status-pill-dot">{pill.glyph}</span>
      {pill.label}
    </span>
  );

  const decoratedChildren = (
    <>
      {pillNode}
      {tileElement.props.children}
    </>
  );

  return React.cloneElement(
    tileElement,
    {
      className: `${existingClass} service-tile-interactive`.trim(),
      'data-status': safeStatus,
    },
    decoratedChildren
  );
};

export default ServiceTile;
